import clsx from 'clsx';
import { Button } from 'components';
import debounce from 'lodash.debounce';
import { getClientsListSize } from 'modules/networkTools/localStorageTokens';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getClientsList } from 'store/clients/clientsActions';
import { setSearchText, clearSearchText } from 'store/clients/clientsSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useResponsive } from 'utils/hooks/useMediaQuery';
import { useFlags } from 'launchdarkly-react-client-sdk';

import style from './searchBar.module.scss';

const SearchBar = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  const { enableMpiUpdate } = useFlags();

  const { searchText, filters, clientsList, clientsListLoading } = useAppSelector(
    (state) => state.clients
  );
  const { size } = clientsList;

  const returnStatuses = (statusesFilter: any) => {
    let statuses = '';
    if (Object.keys(statusesFilter).length) {
      const arr = Object.entries(statusesFilter)
        .map((a: any) => {
          if (a[1]?.length > 0) return `${a[0]}=${a[1]}`;
        })
        .filter((b) => b !== undefined);
      statuses = arr.length > 0 ? arr.join('&') : '';
    }
    return statuses;
  };

  const onSearch = (event: any, statuses: any) => {
    if (!event.target.value.length) {
      dispatch(clearSearchText());
    }
    dispatch(
      getClientsList({
        page: 0,
        size,
        q: event.target.value,
        statuses: event.target.value.length === 0 ? returnStatuses(statuses) : ''
      })
    );
  };

  const debouncedChangeHandler = useRef(
    debounce(async (event, statuses) => onSearch(event, statuses), 500)
  ).current;

  const handleChangeSearch = async (event: any) => {
    const searchtext = event.target.value;
    dispatch(setSearchText(searchtext));
    await debouncedChangeHandler(event, filters);
  };

  const onCloseSearchIcon = () => {
    if (searchText) {
      dispatch(
        getClientsList({
          page: 0,
          size: isMobile ? getClientsListSize() ?? 10 : 10,
          statuses: returnStatuses(filters)
        })
      );
    }
    dispatch(clearSearchText());
  };

  return (
    <div
      className={clsx(
        style.searchWrap,
        style.searchWrapAdd,
        searchText && style.searchWrapAddActive
      )}
    >
      <div className={clsx(style.searchInput, style.search)}>
        <span className={clsx('material-icons', style.icon)}>search</span>
        <input
          value={searchText}
          onChange={handleChangeSearch}
          type="text"
          placeholder={
            enableMpiUpdate
              ? 'Search or Add Client (Name, MRN/Client ID, or IMPaCT ID)'
              : 'Search or Add Client (Name or ID)'
          }
        />
        {searchText && (
          <span
            onClick={onCloseSearchIcon}
            className={clsx('material-icons-outlined', style.iconClose)}
          >
            cancel
          </span>
        )}
      </div>
      {searchText.length > 0 && (
        <Button
          disabled={clientsListLoading}
          theme="secondary"
          size="small"
          icon={<span className={'material-icons-outlined'}>add</span>}
          customStyleClass={style.addClientButton}
          text="Add New Client"
          handleOnClick={() => navigate('new/profile')}
        />
      )}
    </div>
  );
};

export default SearchBar;
